// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__3MayL","containerItemsCenter":"Skeleton_containerItemsCenter__3Kjzf"};